import differ from '../differ'

function checkSingle(requires, has) {
  const _requires = (requires || '').trim().split('.')
  const _has = (has || '').trim().split('.')

  for (let level = 0; level < _requires.length; level++) {
    if (_has[level] === '*')
      return true
    if (_requires[level] !== _has[level])
      return false
  }

  if (_has.length > _requires.length)
    return false
  return true
}

function check(requires, has) {
  requires = requires || []
  has = has || []

  if (!Array.isArray(requires))
    requires = [requires]
  if (!Array.isArray(has))
    has = [has]

  const excludings = has.filter(i => (i || '').startsWith('!')).map(i => i.slice(1))
  has = has.filter(i => !(i || '').startsWith('!'))

  for (const require of requires) {
    let passed = false
    for (const have of has) {
      if (checkSingle(require, have)) {
        let excluded = false
        // Check if it's excluded
        for (const exclude of excludings) {
          if (checkSingle(require, exclude))
            excluded = true
        }
        passed = !excluded
        break
      }
    }
    if (!passed)
      return false
  }
  return true
}

function requests(requires) {
  return {
    has(has) {
      return check(requires, has)
    },
  }
}

export default {
  checkSingle,
  check,
  requests,
}



// WEBPACK FOOTER //
// ./modules/permission/index.js